import React, { useMemo } from "react";
import { Paper, Box, Typography, Stack, LinearProgress } from "@mui/material";

const DEFAULT_LABELS = [
    { key: "FIRST_CONTACT", label: "Primeiro Contato" },
    { key: "QUALIFICATION", label: "Qualificação" },
    { key: "DATA_COLLECTION", label: "Coleta de Dados" },
    { key: "SCHEDULING", label: "Agendamento" },
    { key: "ENROLLED", label: "Matrícula" },
];

export default function StageDistributionCard({ data }) {
    const items = useMemo(() => {
        const safe = data && typeof data === "object" ? data : {};
        const total = Object.values(safe).reduce(
            (sum, v) => sum + (Number(v) || 0),
            0
        );

        return {
            total,
            rows: DEFAULT_LABELS.map(({ key, label }) => {
                const value = Number(safe[key] || 0);
                const pct = total > 0 ? (value / total) * 100 : 0;
                return { key, label, value, pct };
            }),
        };
    }, [data]);

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                border: "1px solid var(--border)",
                background: "var(--branco)",
            }}
        >
            <Box sx={{ mb: 1 }}>
                <Typography sx={{ fontWeight: 800, color: "var(--cise-blue)" }}>
                    Saúde do Funil
                </Typography>
                <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
                    Distribuição por estágio (visão rápida de gargalos)
                </Typography>
            </Box>

            <Stack spacing={1.2}>
                {items.rows.map((row) => (
                    <Box key={row.key}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "baseline",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography sx={{ fontSize: 13, color: "var(--cise-text)" }}>
                                {row.label}
                            </Typography>
                            <Typography sx={{ fontSize: 13, color: "var(--cise-text-muted)" }}>
                                {row.value}
                            </Typography>
                        </Box>

                        <LinearProgress
                            variant="determinate"
                            value={row.pct}
                            sx={{
                                mt: 0.6,
                                height: 8,
                                borderRadius: 999,
                                backgroundColor: "rgba(255,255,255,0.08)",
                                "& .MuiLinearProgress-bar": {
                                    borderRadius: 999,
                                    backgroundColor: "var(--cise-blue)",
                                },
                            }}
                        />
                    </Box>
                ))}

                <Box sx={{ pt: 1, display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{ fontSize: 12, color: "var(--cise-text-muted)" }}>
                        Total
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "var(--cise-text)" }}>
                        {items.total}
                    </Typography>
                </Box>
            </Stack>
        </Paper>
    );
}